import {
    IFormImageSelectionProps,
    ImageSelectionForm,
    TDialogStore,
    useDialogStore,
} from '@eventr/common-storybook'
import { useShallow } from 'zustand/react/shallow'
import { FilePickerDialog } from '../../../common/FilePickerDialog'
import { bs } from '../../../state/bound.store'
import { defaultAddSnack } from '../../../state/overlayState/overlayContext'

export const AppFormImageSelect = (props: IFormImageSelectionProps) => {
    const { replaceDialog }: TDialogStore = useDialogStore(
        useShallow((s: TDialogStore) => ({
            replaceDialog: s.replaceDialog,
        }))
    )
    return (
        <ImageSelectionForm
            {...props}
            onError={(e) => {
                defaultAddSnack(e, 'error')
            }}
            onUpload={(f) => {
                return bs().uploadMedia(f, 'HeaderImage')
            }}
            openFileDialog={(onFileSelected) =>
                replaceDialog({
                    node: (
                        <FilePickerDialog
                            onFileSelected={(file: File) => {
                                onFileSelected(file)
                            }}
                        />
                    ),
                    backdropClosable: false,
                })
            }
        />
    )
}
